export default "__VITE_ASSET__zM4eburp__"